import RenderManager from "../rendering/render-manager";

class ScalpelPlane extends THREE.Group {
    _slicer = null;
    _visualizer = null;

    constructor() {
        const planeSize = 1;
        const material = new THREE.MeshBasicMaterial({ color: 0xff00ff, side: THREE.BackSide });
        const geometry = new THREE.BoxBufferGeometry(planeSize, planeSize, planeSize * 100, 1, 1);

        super();
        this._slicer = new THREE.Mesh(geometry, material);

        this.name = "Scalpel Plane";
        this.type = "ScalpelPlane";
        this.isScalpelPlane = true;
        geometry.translate(0, 0, planeSize * 50);

        // this.add(this._slicer);

        if (Q3.editMode) {
            const materialPlane = new THREE.MeshBasicMaterial({ color: 0xffff00, transparent: true, opacity: 0.5 });
            const geometryPlane = new THREE.PlaneBufferGeometry(planeSize, planeSize, 1, 1);
            const materialLine = new THREE.LineBasicMaterial({ color: 0xff00ff });
            const geometryLine = new THREE.EdgesGeometry(geometryPlane);
            const planeVisualizer = new THREE.Mesh(geometryPlane, materialPlane);
            const linesVisualizer = new THREE.LineSegments(geometryLine, materialLine);

            geometryPlane.rotateY(Math.PI);

            planeVisualizer.isNotSelectable = true;
            planeVisualizer.overridePicker = this;
            linesVisualizer.isNotSelectable = true;

            planeVisualizer.add(linesVisualizer);
            this._visualizer = planeVisualizer;

            this.add(planeVisualizer);

            RenderManager.raycaster.makeTrackable(planeVisualizer);
        }

        geometry.computeBoundingBox();
    }

    get slicer() { return this._slicer; }
    get visualizer() { return this._visualizer; }
}

export default ScalpelPlane;
export { ScalpelPlane };